import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({
  isCompression: false,
  encodingType: "aes",
  encryptionSecret: "Ef@cT0321NgP$$w0rd@123",
});
import VueCookies from "vue-cookies";
import gbfEncoder from "@/components/globalFunctions/encode.js";
import Swal from "sweetalert2";
Vue.use(VueCookies);
// expire path domian secure
Vue.$cookies.config("1d", null, null, true);
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    st_authorize: false,
    st_oneaccesstoken: "",
    st_profile_active: {},
    st_business_account: [],
    st_profile_account: {},
    typeAttStore: localStorage.getItem("typeAttStore") || "inv", // โหลดค่าจาก localStorage
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
    },
    login_oneid_sso_fail(state) {
      state.st_authorize = false;
      state.st_oneaccesstoken = "";
      state.st_profile_active = {};
      state.st_business_account = [];
      state.st_profile_account = {};
    },
    login_oneid_sso_success(state, data) {
      console.log("update state", data);
      // destructuring
      const {
        accessToken,
        biz_detail,
        biz_id,
        first_name_eng,
        first_name_th,
        last_name_eng,
        last_name_th,
        id,
        username,
        email,
        thai_email,
        account_title_th,
        account_title_eng,
        thai_email2,
      } = data;
      state.st_authorize = true;
      state.st_oneaccesstoken = data.accessToken;
      // state.st_profile_active =
      //   data.biz_detail.length > 0 ? { type: "business", biz_detail: data.biz_detail[0] } : { type: "citizen", biz_detail: [] };
      state.st_profile_active = {
        type: "citizen",
        biz_detail: [],
        status_superAdmin: "false",
        permission: {},
        rating: "false",
      };
      state.st_business_account = data.biz_detail;
      // state.st_profile_account = data;
      state.st_profile_account = {
        accessToken,
        biz_detail,
        biz_id,
        first_name_eng,
        first_name_th,
        last_name_eng,
        last_name_th,
        id,
        username,
        email,
        thai_email,
        account_title_th,
        account_title_eng,
        thai_email2,
      };
    },
    logout_oneid_sso(state) {
      state.st_authorize = false;
      state.st_oneaccesstoken = "";
      state.st_profile_active = {};
      state.st_business_account = [];
      state.st_profile_account = {};
    },
    switch_account(state, data) {
      if (data.type === "citizen") {
        state.st_profile_active = {
          type: "citizen",
          biz_detail: [],
          status_superAdmin: "false",
          permission: {},
          rating: "false",
        };
      } else {
        let checkindex = state.st_business_account.findIndex(
          (fx) => fx.biz_id === data.biz_id
        );
        if (checkindex !== -1) {
          state.st_profile_active = {
            type: "business",
            biz_detail: state.st_business_account[checkindex],
            // ! เก็บค่า status ลงไปใน vuex ต้องไปเพิ่ม data ที่ action switch_account ก่อน
            status_superAdmin: data.status_superAdmin || "false",
            permission: data.permission,
            rating: data.rating,
            status_payment: data.status_payment || false,
            role_ra: data.role_ra || false,
          };
        } else {
          state.st_profile_active =
            data.biz_detail.length > 0
              ? {
                  type: "business",
                  biz_detail: data.biz_detail[0],
                  status_superAdmin: "false",
                  permission: {},
                  rating: "false",
                  status_payment: false,
                }
              : {
                  type: "citizen",
                  biz_detail: [],
                  status_superAdmin: "false",
                  permission: {},
                  rating: "false",
                  status_payment: false,
                };
        }
      }
    },
    setTypeAtt(state, value) {
      state.typeAttStore = value;
      localStorage.setItem("typeAttStore", value); // บันทึกค่าลง localStorage
    },
  },
  actions: {
    //! action ต้อง return เป็น new Prmise
    //! ใช้เป็น async
    setUser({ commit }) {
      //! เข้าไปเปลี่ยนค่าที่ mutation
      commit("setUser", "sss");
    },
    // ! Login
    async login_oneid_sso({ commit }, data) {
      let data_return = {};
      try {
        let payload = {
          token: data,
        };
        const payload_encode = await gbfEncoder.encodeBodyRequest(payload);
        const header_request = { headers: payload_encode.header };
        let result = await axios.post(
          process.env.VUE_APP_API_FACTORING_SELLER + "/login/loginBySSO",
          payload_encode.body,
          header_request
        );
        const response_api = gbfEncoder.decodeResponse(result);
        if (response_api.status === "OK") {
          Vue.$cookies.set("seller_authorize", true);
          Vue.$cookies.set(
            "seller_accesstoken",
            "ok" || response_api.message.username
          );
          // ! ไป mutation success
          commit("setTypeAtt", 'inv');
          commit("login_oneid_sso_success", response_api.message);
          data_return = { status: "OK", errorMessage: "" };
        } else {
          // ! ไป mutation fail
          commit("login_oneid_sso_fail");
          data_return = {
            status: "ER",
            errorMessage: response_api.errorMessage,
          };
        }
      } catch (error) {
        console.log("login_oneid_sso:", error);
        if (error.response) {
          //? Request made and server responded
          const responseError =
            "message" in error.response.data
              ? gbfEncoder.decodeBodyRequest(error.response.data.message)
              : error.response.data;
          data_return = {
            status: "ER",
            errorMessage: responseError.errorMessage,
          };
        } else if (error.request) {
          //? The request was made but no response was received
          data_return = { status: "ER", errorMessage: error.request };
        } else {
          data_return = { status: "ER", errorMessage: String(error) };
        }
        // ! ไป mutation fail
        commit("login_oneid_sso_fail");
      }
      return new Promise((resolve, reject) => {
        resolve(data_return);
      });
    },
    // ! Login e-Factoring
    async login_efactoring({ commit }, data) {
      let data_return = {};
      try {
        const payload_encode = await gbfEncoder.encodeBodyRequest(data);
        const header_request = { headers: payload_encode.header };
        let result = await axios.post(
          process.env.VUE_APP_API_FACTORING_SELLER + "/login/loginByPWD",
          payload_encode.body,
          header_request
        );
        console.log("result", result);
        const response_api = gbfEncoder.decodeResponse(result);
        console.log("response", response_api);
        if (response_api.status === "OK") {
          Vue.$cookies.set("seller_authorize", true);
          Vue.$cookies.set(
            "seller_accesstoken",
            "ok" || response_api.message.username
          );
          // ! ไป mutation success
          commit("setTypeAtt", 'inv');
          commit("login_oneid_sso_success", response_api.message);
          data_return = { status: "OK", errorMessage: "" };
        } else {
          // ! ไป mutation fail
          commit("login_oneid_sso_fail");
          data_return = {
            status: "ER",
            errorMessage: response_api.errorMessage,
          };
        }
      } catch (error) {
        console.log("error", error);
        if (error.response) {
          //? Request made and server responded
          const responseError =
            "message" in error.response.data
              ? gbfEncoder.decodeBodyRequest(error.response.data.message)
              : error.response.data;
          data_return = {
            status: "ER",
            errorMessage: responseError.errorMessage,
          };
        } else if (error.request) {
          //? The request was made but no response was received
          data_return = { status: "ER", errorMessage: error.request };
        } else {
          data_return = { status: "ER", errorMessage: String(error) };
        }
        // ! ไป mutation fail
        commit("login_oneid_sso_fail");
      }
      return new Promise((resolve, reject) => {
        resolve(data_return);
      });

      // ! ไป mutation success
      // commit("setTypeAtt", 'inv');
      // Vue.$cookies.set("seller_authorize", true);
      // Vue.$cookies.set("seller_accesstoken", data.accessToken);
      // commit("login_oneid_sso_success", data);
    },
    // ! Login by accessToken
    async login_accesstoken({ commit }, data) {
      let data_return = {};
      try {
        let payload = {
          accessToken: data.accesstoken,
        };
        const payload_encode = await gbfEncoder.encodeBodyRequest(payload);
        const header_request = { headers: payload_encode.header };
        let result = await axios.post(
          process.env.VUE_APP_API_FACTORING_SELLER + "/profile/getProfile",
          payload_encode.body,
          header_request
        );
        const response_api = gbfEncoder.decodeResponse(result);
        if (response_api.status === "OK") {
          Vue.$cookies.set("seller_authorize", true);
          Vue.$cookies.set(
            "seller_accesstoken",
            "ok" || response_api.message.username
          );
          // ! mutation success
          commit("setTypeAtt", 'inv');
          await commit("login_oneid_sso_success", response_api.message);
          // ! Get biz_id form taxid
          let getbiz_id = this.state.st_business_account.find(
            (item) => item.getbiz[0].id_card_num === data.taxid
          );
          // ! Create data for switch biz
          let obj = {
            type: "business",
            biz_id: getbiz_id.biz_id,
            taxid: data.taxid,
          };
          // ! Switch to biz
          await this.dispatch("switch_account", obj);
          data_return = { status: "OK", errorMessage: "" };
        }
      } catch (error) {
        console.log("checking_authorize:", error.errorMessage);
        if (error.response) {
          //? Request made and server responded
          const responseError =
            "message" in error.response.data
              ? gbfEncoder.decodeBodyRequest(error.response.data.message)
              : error.response.data;
          data_return = {
            status: "ER",
            errorMessage: responseError.errorMessage,
          };
        } else if (error.request) {
          //? The request was made but no response was received
          data_return = { status: "ER", errorMessage: error.request };
        } else if (
          error instanceof TypeError &&
          error.message.includes(
            `Cannot read properties of undefined (reading 'biz_id')`
          )
        ) {
          data_return = {
            status: "ER",
            errorMessage: `go to regis, please follow this link: \n ${process.env.VUE_APP_URL_LANDINGPAGE}/register-page`,
          };
          let html = `
          <div>
            <p>เนื่องจากไม่พบข้อมูลบัญชีบริษัทของท่าน</p>
            <br />
            <p>กรุณาลงทะเบียนเพื่อเข้าสู่ระบบ</p>
          </div>
          `;
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถดำเนินการได้",
            // text: "บัญชี/บริษัทของคุณยังไม่ได้สมัครเป็น Seller กรุณาลงทะเบียนก่อน",
            html: html,
            confirmButtonText: "ลงทะเบียน",
            confirmButtonColor: "#71A727",
          }).then((res) => {
            if (res.isConfirmed)
              window.location.href = `${process.env.VUE_APP_URL_LANDINGPAGE}/register-page`;
          });
        } else if (
          error.errorMessage ==
          "ไม่พบข้อมูลบัญชี/บริษัทของคุณในระบบ e-Factoring กรุณาติดต่อแอดมินระบบ"
        ) {
          let html = `
          <div>
            <p>เนื่องจากไม่พบข้อมูลบัญชีบริษัทของท่าน</p>
            <p>กรุณาลงทะเบียนเพื่อเข้าสู่ระบบ</p>
          </div>
          `;
          // ! ให้ error แล้วไปหน้าลงทะเบียนที่ landding ก่อน
          Swal.fire({
            icon: "error",
            title: "เข้าสู่ระบบไม่สำเร็จ",
            // text: "ไม่พบข้อมูลบัญชี/บริษัทของคุณในระบบ e-Factoring กรุณาลงทะเบียน",
            html: html,
            confirmButtonText: "ลงทะเบียน",
            confirmButtonColor: "#71A727",
          }).then((res) => {
            if (res.isConfirmed)
              window.location.href = `${process.env.VUE_APP_URL_LANDINGPAGE}/services?status=register`;
          });
        } else {
          data_return = {
            status: "ER",
            errorMessage: error.errorMessage || error,
          };
        }
        // ! mutation fail
        commit("login_oneid_sso_fail");
      }
      return new Promise((resolve, reject) => {
        resolve(data_return);
      });
    },
    // ! Logout
    async logout_service({ commit }) {
      Vue.$cookies.set("seller_authorize", false);
      Vue.$cookies.set("seller_accesstoken", "");
      commit("logout_oneid_sso");
      return new Promise((resolve, reject) => {
        resolve({ status: "OK", errorMessage: "" });
      });
    },
    // ! Check Authorize
    async checking_authorize({ commit }) {
      let data_return = {};
      try {
        if (Vue.$cookies.isKey("seller_authorize") === true) {
          if (Vue.$cookies.get("seller_accesstoken") != "") {
            let payload = {
              accessToken: Vue.$cookies.get("seller_accesstoken"),
            };
            const payload_encode = await gbfEncoder.encodeBodyRequest(payload);
            const header_request = { headers: payload_encode.header };
            let result = await axios.post(
              process.env.VUE_APP_API_FACTORING_SELLER + "/profile/getProfile",
              payload_encode.body,
              header_request
            );
            const response_api = gbfEncoder.decodeResponse(result);
            console.log("checking_authorize", result);
            if (response_api.status === "OK") {
              Vue.$cookies.set("seller_authorize", true);
              Vue.$cookies.set(
                "seller_accesstoken",
                "ok" || response_api.message.username
              );
              // ! ไป mutation success
              commit("setTypeAtt", 'inv');
              commit("login_oneid_sso_success", response_api.message);
              data_return = { status: "OK", errorMessage: "" };
            } else {
              Vue.$cookies.set("seller_authorize", true);
              Vue.$cookies.set("seller_accesstoken", "");
              // ! ไป mutation fail
              commit("login_oneid_sso_fail");
              data_return = {
                status: "ER",
                errorMessage: response_api.errorMessage,
              };
            }
          } else {
            Vue.$cookies.set("seller_authorize", false);
            Vue.$cookies.set("seller_accesstoken", "");
            data_return = { status: "ER", errorMessage: "SESSION INVALID" };
            console.log(
              "checking_authorize: seller_authorize !== true, seller_accesstoken NULL "
            );
          }
        } else {
          Vue.$cookies.set("seller_authorize", false);
          Vue.$cookies.set("seller_accesstoken", "");
          // ! ไป mutation fail
          commit("login_oneid_sso_fail");
          data_return = { status: "ER", errorMessage: "NO SESSION" };
          console.log(
            "checking_authorize: not cookies seller_authorize & seller_accesstoken"
          );
        }
      } catch (error) {
        console.log("checking_authorize:", error);
        if (error.response) {
          //? Request made and server responded
          const responseError =
            "message" in error.response.data
              ? gbfEncoder.decodeBodyRequest(error.response.data.message)
              : error.response.data;
          data_return = {
            status: "ER",
            errorMessage: responseError.errorMessage,
          };
        } else if (error.request) {
          //? The request was made but no response was received
          data_return = { status: "ER", errorMessage: error.request };
        } else {
          data_return = { status: "ER", errorMessage: String(error) };
        }
        // ! ไป mutation fail
        commit("login_oneid_sso_fail");
      }
      return new Promise((resolve, reject) => {
        resolve(data_return);
      });
    },
    // ! Switch Account
    async switch_account({ commit }, data) {
      // let data_return = { status: "OK", errorMessage: "", data: data };
      let data_return = {};
      try {
        //! ไป mutation switch account
        if (data.type === "business") {
          let checkindex = this.state.st_business_account.findIndex(
            (fx) => fx.biz_id === data.biz_id
          );
          if (checkindex === -1) {
            // ! กรณีหาเลข taxid ไม่เจอ
            console.log("Not found taxid in this account");
            data_return = {
              status: "ER",
              errorMessage:
                "บัญชี/บริษัทของคุณยังไม่ได้สมัครเป็น Seller กรุณาติดต่อแอดมินระบบ",
            };
            return new Promise((resolve, reject) => {
              reject(data_return);
            });
          }
          //! sellerBranch branch เขียนผิด bracnh น่าจะจาก oneid ส่งมาผิด
          let payloadV2 = {
            accessToken: this.state.st_profile_account.accessToken,
            sellerId: data.taxid,
            sellerBranch:
              this.state.st_business_account[checkindex].getbiz[0].bracnh ||
              "00000",
            accountId: this.state.st_profile_account.id,
            bizId: this.state.st_business_account[checkindex].biz_id,
          };
          const payload_encode = await gbfEncoder.encodeBodyRequest(payloadV2);
          const header_request = { headers: payload_encode.header };
          let result = await axios.post(
            process.env.VUE_APP_API_FACTORING_SELLER + "/login/checkSellerV2",
            payload_encode.body,
            header_request
          );
          const response_api = gbfEncoder.decodeResponse(result);
          console.log("result", response_api);
          if (response_api.status === "OK") {
            // ! เอา status กับ permission  มาเก็บในนี้
            data.permission = response_api.message.menu_permission;
            data.status_superAdmin =
              response_api.message.status_superAdmin || "false";
            data.rating = response_api.message.rating_status || "false";
            data.status_payment = response_api.message.status_payment || false;
            data.role_ra = response_api.message.role_ra || false;
            commit("switch_account", data);
            data_return = { status: "OK", errorMessage: "" };
          } else {
            console.log("ER", result);
            data_return = {
              status: "ER",
              errorMessage: response_api.errorMessage,
            };
            console.log("data return", data_return);
            return new Promise((resolve, reject) => {
              reject(data_return);
            });
          }
        } else {
          commit("switch_account", data);
          data_return = { status: "OK", errorMessage: "" };
        }
      } catch (error) {
        console.log("switch_account", error);
        if (error.response) {
          const responseError =
            "message" in error.response.data
              ? gbfEncoder.decodeBodyRequest(error.response.data.message)
              : error.response.data;
          data_return = {
            status: "ER",
            errorMessage: responseError.errorMessage,
          };
        } else if (error.request) {
          console.log(error.request);
          data_return = { status: "ER", errorMessage: error.request };
        } else {
          console.error("Error", error.message || error);
          data_return = { status: "ER", errorMessage: error.message || error };
        }
        return new Promise((resolve, reject) => {
          reject(data_return);
        });
      }
    },
    // ! Update Tab INV/CDN
    updateTypeAtt({ commit }, value) {
      commit("setTypeAtt", value);
    },
  },
  modules: {},

  getters: {
    gettersAuthorize: (state) => {
      return state.st_authorize;
    },
    gettersOneaccesstoken: (state) => {
      return state.st_oneaccesstoken;
    },
    gettersProfileActive: (state) => {
      return state.st_profile_active;
    },
    gettersBusinessAccount: (state) => {
      return state.st_business_account;
    },
    gettersProfileAccount: (state) => {
      return state.st_profile_account;
    },
    getTypeAtt: (state) => state.typeAttStore,
  },
  plugins: [
    createPersistedState({
      key: "factoring-sellerPersistedState",
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
